import breakUrl from './breakUrl';

export default breakUrl;
